/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: qafHkE927CrC

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Popover } from "@plasmicpkgs/radix-ui";
import HomeBenefitsSectionRoleDropdownItem from "../../HomeBenefitsSectionRoleDropdownItem"; // plasmic-import: PJXTdMLnvs2R/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeBenefitsSectionRoleDropdown.module.css"; // plasmic-import: qafHkE927CrC/css

import OverlayIcon from "./icons/PlasmicIcon__Overlay"; // plasmic-import: DUBaIaV24j-h/icon
import Icon64Icon from "./icons/PlasmicIcon__Icon64"; // plasmic-import: WzuZ8AOmVWTQ/icon

createPlasmicElementProxy;

export type PlasmicHomeBenefitsSectionRoleDropdown__VariantMembers = {};
export type PlasmicHomeBenefitsSectionRoleDropdown__VariantsArgs = {};
type VariantPropType =
  keyof PlasmicHomeBenefitsSectionRoleDropdown__VariantsArgs;
export const PlasmicHomeBenefitsSectionRoleDropdown__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeBenefitsSectionRoleDropdown__ArgsType = {
  onValueChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicHomeBenefitsSectionRoleDropdown__ArgsType;
export const PlasmicHomeBenefitsSectionRoleDropdown__ArgProps =
  new Array<ArgPropType>("onValueChange");

export type PlasmicHomeBenefitsSectionRoleDropdown__OverridesType = {
  roleDropdown?: Flex__<"div">;
  popoverCore?: Flex__<typeof Popover>;
  input?: Flex__<"span">;
  directorAvatar?: Flex__<"div">;
  img2?: Flex__<"div">;
  officerAvatar?: Flex__<"div">;
  img3?: Flex__<"div">;
  adminAvatar?: Flex__<"div">;
  img4?: Flex__<"div">;
  text10?: Flex__<"div">;
  role2?: Flex__<"div">;
  name?: Flex__<"div">;
  rightIcon?: Flex__<"button">;
  dropdown?: Flex__<"div">;
  homeBenefitsSectionRoleDropdownItem?: Flex__<
    typeof HomeBenefitsSectionRoleDropdownItem
  >;
};

export interface DefaultHomeBenefitsSectionRoleDropdownProps {
  onValueChange?: (val: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeBenefitsSectionRoleDropdown__RenderFunc(props: {
  variants: PlasmicHomeBenefitsSectionRoleDropdown__VariantsArgs;
  args: PlasmicHomeBenefitsSectionRoleDropdown__ArgsType;
  overrides: PlasmicHomeBenefitsSectionRoleDropdown__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "value",
        type: "readonly",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "director",

        onChangeProp: "onValueChange"
      },
      {
        path: "popoverCore.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"roleDropdown"}
      data-plasmic-override={overrides.roleDropdown}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.roleDropdown
      )}
    >
      <Popover
        data-plasmic-name={"popoverCore"}
        data-plasmic-override={overrides.popoverCore}
        align={
          hasVariant(globalVariants, "mobile", "mobileXSmall")
            ? "center"
            : hasVariant(globalVariants, "mobile", "mobile")
              ? "start"
              : undefined
        }
        className={classNames("__wab_instance", sty.popoverCore)}
        onOpenChange={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["popoverCore", "open"]).apply(
            null,
            eventArgs
          );
        }}
        open={generateStateValueProp($state, ["popoverCore", "open"])}
        overlay={
          <div
            data-plasmic-name={"dropdown"}
            data-plasmic-override={overrides.dropdown}
            className={classNames(projectcss.all, sty.dropdown)}
          >
            {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
              (() => {
                try {
                  return [
                    {
                      label: "Director"
                    },
                    {
                      label: "Officer"
                    },
                    {
                      label: "Administrator"
                    }
                  ];
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()
            ).map((__plasmic_item_0, __plasmic_idx_0) => {
              const currentItem = __plasmic_item_0;
              const currentIndex = __plasmic_idx_0;
              return (
                <HomeBenefitsSectionRoleDropdownItem
                  data-plasmic-name={"homeBenefitsSectionRoleDropdownItem"}
                  data-plasmic-override={
                    overrides.homeBenefitsSectionRoleDropdownItem
                  }
                  active={(() => {
                    try {
                      return currentItem.label.toLowerCase() === $state.value;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  className={classNames(
                    "__wab_instance",
                    sty.homeBenefitsSectionRoleDropdownItem
                  )}
                  key={currentIndex}
                  onClick={async () => {
                    const $steps = {};

                    $steps["updateValue"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["value"]
                            },
                            operation: 0,
                            value: currentItem.label.toLowerCase()
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateValue"] != null &&
                      typeof $steps["updateValue"] === "object" &&
                      typeof $steps["updateValue"].then === "function"
                    ) {
                      $steps["updateValue"] = await $steps["updateValue"];
                    }

                    $steps["updateValue2"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["popoverCore", "open"]
                            },
                            operation: 0,
                            value: false
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateValue2"] != null &&
                      typeof $steps["updateValue2"] === "object" &&
                      typeof $steps["updateValue2"].then === "function"
                    ) {
                      $steps["updateValue2"] = await $steps["updateValue2"];
                    }
                  }}
                  pov={(() => {
                    try {
                      return currentItem.label.toLocaleLowerCase();
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                />
              );
            })}
          </div>
        }
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames
        )}
      >
        <span
          data-plasmic-name={"input"}
          data-plasmic-override={overrides.input}
          aria-label={(() => {
            try {
              return $state.popoverCore.open
                ? "Collapse role dropdown"
                : "Expand role dropdown";
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          className={classNames(projectcss.all, projectcss.span, sty.input)}
          role={"button"}
          title={(() => {
            try {
              return $state.popoverCore.open
                ? "Collapse role dropdown"
                : "Expand role dropdown";
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          {(() => {
            try {
              return $state.value === "director";
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <div
              data-plasmic-name={"directorAvatar"}
              data-plasmic-override={overrides.directorAvatar}
              className={classNames(projectcss.all, sty.directorAvatar)}
            >
              <div
                data-plasmic-name={"img2"}
                data-plasmic-override={overrides.img2}
                className={classNames(projectcss.all, sty.img2)}
              />

              <OverlayIcon
                className={classNames(projectcss.all, sty.svg__wgr2E)}
                role={"img"}
              />
            </div>
          ) : null}
          {(() => {
            try {
              return $state.value === "officer";
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div
              data-plasmic-name={"officerAvatar"}
              data-plasmic-override={overrides.officerAvatar}
              className={classNames(projectcss.all, sty.officerAvatar)}
            >
              <div
                data-plasmic-name={"img3"}
                data-plasmic-override={overrides.img3}
                className={classNames(projectcss.all, sty.img3)}
              />

              <OverlayIcon
                className={classNames(projectcss.all, sty.svg__fiA3J)}
                role={"img"}
              />
            </div>
          ) : null}
          {(() => {
            try {
              return $state.value === "administrator";
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div
              data-plasmic-name={"adminAvatar"}
              data-plasmic-override={overrides.adminAvatar}
              className={classNames(projectcss.all, sty.adminAvatar)}
            >
              <div
                data-plasmic-name={"img4"}
                data-plasmic-override={overrides.img4}
                className={classNames(projectcss.all, sty.img4)}
              />
            </div>
          ) : null}
          <div
            data-plasmic-name={"text10"}
            data-plasmic-override={overrides.text10}
            className={classNames(projectcss.all, sty.text10)}
          >
            <div
              data-plasmic-name={"role2"}
              data-plasmic-override={overrides.role2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.role2
              )}
            >
              <React.Fragment>
                {(() => {
                  switch ($state.value) {
                    case "officer":
                      return "Institutional Officer";
                    case "administrator":
                      return "Administrator";
                    case "director":
                      return "Program Director";
                    default:
                      return "Program Director";
                  }
                })()}
              </React.Fragment>
            </div>
            <div
              data-plasmic-name={"name"}
              data-plasmic-override={overrides.name}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.name
              )}
            >
              <React.Fragment>
                {(() => {
                  switch ($state.value) {
                    case "officer":
                      return "Dan Strategist";
                    case "administrator":
                      return "Anna Facilitator";
                    case "director":
                      return "Mark Achiever";
                    default:
                      return "Mark Achiever";
                  }
                })()}
              </React.Fragment>
            </div>
          </div>
          <button
            data-plasmic-name={"rightIcon"}
            data-plasmic-override={overrides.rightIcon}
            aria-label={"Expand role dropdown"}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.rightIcon
            )}
            ref={ref => {
              $refs["rightIcon"] = ref;
            }}
            title={"Expand role dropdown"}
          >
            <Icon64Icon
              className={classNames(projectcss.all, sty.svg__bHqhZ)}
              role={"img"}
              style={(() => {
                try {
                  return {
                    transform: $state.popoverCore.open
                      ? "rotate(180deg)"
                      : "rotate(0deg)"
                  };
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            />
          </button>
        </span>
      </Popover>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  roleDropdown: [
    "roleDropdown",
    "popoverCore",
    "input",
    "directorAvatar",
    "img2",
    "officerAvatar",
    "img3",
    "adminAvatar",
    "img4",
    "text10",
    "role2",
    "name",
    "rightIcon",
    "dropdown",
    "homeBenefitsSectionRoleDropdownItem"
  ],
  popoverCore: [
    "popoverCore",
    "input",
    "directorAvatar",
    "img2",
    "officerAvatar",
    "img3",
    "adminAvatar",
    "img4",
    "text10",
    "role2",
    "name",
    "rightIcon",
    "dropdown",
    "homeBenefitsSectionRoleDropdownItem"
  ],
  input: [
    "input",
    "directorAvatar",
    "img2",
    "officerAvatar",
    "img3",
    "adminAvatar",
    "img4",
    "text10",
    "role2",
    "name",
    "rightIcon"
  ],
  directorAvatar: ["directorAvatar", "img2"],
  img2: ["img2"],
  officerAvatar: ["officerAvatar", "img3"],
  img3: ["img3"],
  adminAvatar: ["adminAvatar", "img4"],
  img4: ["img4"],
  text10: ["text10", "role2", "name"],
  role2: ["role2"],
  name: ["name"],
  rightIcon: ["rightIcon"],
  dropdown: ["dropdown", "homeBenefitsSectionRoleDropdownItem"],
  homeBenefitsSectionRoleDropdownItem: ["homeBenefitsSectionRoleDropdownItem"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  roleDropdown: "div";
  popoverCore: typeof Popover;
  input: "span";
  directorAvatar: "div";
  img2: "div";
  officerAvatar: "div";
  img3: "div";
  adminAvatar: "div";
  img4: "div";
  text10: "div";
  role2: "div";
  name: "div";
  rightIcon: "button";
  dropdown: "div";
  homeBenefitsSectionRoleDropdownItem: typeof HomeBenefitsSectionRoleDropdownItem;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeBenefitsSectionRoleDropdown__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeBenefitsSectionRoleDropdown__VariantsArgs;
    args?: PlasmicHomeBenefitsSectionRoleDropdown__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<
      PlasmicHomeBenefitsSectionRoleDropdown__VariantsArgs,
      ReservedPropsType
    > &
    // Specify args directly as props
    Omit<PlasmicHomeBenefitsSectionRoleDropdown__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicHomeBenefitsSectionRoleDropdown__ArgProps,
          internalVariantPropNames:
            PlasmicHomeBenefitsSectionRoleDropdown__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeBenefitsSectionRoleDropdown__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "roleDropdown") {
    func.displayName = "PlasmicHomeBenefitsSectionRoleDropdown";
  } else {
    func.displayName = `PlasmicHomeBenefitsSectionRoleDropdown.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeBenefitsSectionRoleDropdown = Object.assign(
  // Top-level PlasmicHomeBenefitsSectionRoleDropdown renders the root element
  makeNodeComponent("roleDropdown"),
  {
    // Helper components rendering sub-elements
    popoverCore: makeNodeComponent("popoverCore"),
    input: makeNodeComponent("input"),
    directorAvatar: makeNodeComponent("directorAvatar"),
    img2: makeNodeComponent("img2"),
    officerAvatar: makeNodeComponent("officerAvatar"),
    img3: makeNodeComponent("img3"),
    adminAvatar: makeNodeComponent("adminAvatar"),
    img4: makeNodeComponent("img4"),
    text10: makeNodeComponent("text10"),
    role2: makeNodeComponent("role2"),
    _name: makeNodeComponent("name"),
    rightIcon: makeNodeComponent("rightIcon"),
    dropdown: makeNodeComponent("dropdown"),
    homeBenefitsSectionRoleDropdownItem: makeNodeComponent(
      "homeBenefitsSectionRoleDropdownItem"
    ),

    // Metadata about props expected for PlasmicHomeBenefitsSectionRoleDropdown
    internalVariantProps: PlasmicHomeBenefitsSectionRoleDropdown__VariantProps,
    internalArgProps: PlasmicHomeBenefitsSectionRoleDropdown__ArgProps
  }
);

export default PlasmicHomeBenefitsSectionRoleDropdown;
/* prettier-ignore-end */
